<div class="payments-schedules">

  <div class="frecuency">
    <span class="frecuency__title">Frecuencia</span>
    <span class="frecuency__subtitle">Selecciona cada cuándo se realizará la recarga.</span>

    <div class="frecuency__options">
      <ng-container *ngFor="let item of arrayFrecuency">
        <flame-chip [selected]="item.active"
           (selectionChange)="clickChip(item)" 
        > {{ item.label }} </flame-chip>
      </ng-container>
    </div>
  </div>

  <div class="section-date" [ngClass]="{'section-date--open': isActiveCalendar}">
    <div class="section-date__title">Selecciona la fecha de <span>tu primer recarga automática.</span></div>

    <flame-chip
      class="section-date__chip"
      (selectionChange)="selectDay($event)"
      selected
    >
      <flame-icon svgIcon="add-to-calendar" size="s"></flame-icon>
      <span>{{dateFormatSelected}}</span>
    </flame-chip>

  </div>
  <ng-container *ngIf="isActiveCalendar">
    <div class="section-calendar">
      <ta-flame-calendar
        [startDate]="dateCalendar"
        [currentDate]="dateCalendar"
        (currentDateChange)="eventSelectedDay($event)"
      >
      </ta-flame-calendar>
    </div>
  </ng-container>
    

  <app-select-amount [amount]="amount" [schedule]="true" (showAmounts)="onAmounts($event)" />

  <form class="form-alias" [formGroup]="formRecharge">
    <flame-form-field>
    <flame-label><label for="alias">Alias de recarga programada</label></flame-label>
      <input
        flameInput
        type="text"
        id="alias"
        placeholder=""
        maxlength="20"
        (input)="allowOnlyLetters($event)"
        autocomplete="off"
        formControlName="alias" />
    </flame-form-field>

    <div class="btn-container">
      <button
        flameButton
        [disabled]="!activeBtnForm"
        color="primary"
        (click)="saveRecharge()"
      > 
        Guardar
      </button>
    </div>
  </form>
</div>